if (!customElements.get('ff-products-slider-tabs')) {
  customElements.define('ff-products-slider-tabs', class extends HTMLElement {
    connectedCallback() {
      this.tabs = this.querySelectorAll('.ff-pdc-tab');
      this.ffSlider = this.querySelector('ff-slider');
      this.splideInstance = null;
      this.cache = {}; // index -> HTML de los <li> ya resueltos

      this.tabs.forEach(tab => {
        tab.addEventListener('click', this.handleTabClick.bind(this));
        // Prefetch al pasar el puntero (desktop): el cambio de tab sale instantaneo sin esperar la red
        tab.addEventListener('pointerenter', () => this.fetchTab(tab).catch(() => {}), { once: true });
      });

      this.initSplideInstance();
    }

    initSplideInstance() {
      if (this.ffSlider && this.ffSlider.splide) {
        this.splideInstance = this.ffSlider.splide;
        // El tab activo (0) viene inline en el HTML: lo cacheamos para volver a el sin re-fetch
        const list = this.ffSlider.querySelector('.splide__list');
        if (list && this.cache[0] == null) this.cache[0] = list.innerHTML;
        this.splideInstance.refresh();
      } else {
        setTimeout(() => this.initSplideInstance(), 100);
      }
    }

    async fetchTab(tab) {
      const index = tab.dataset.collectionIndex;
      if (this.cache[index] != null) return this.cache[index];
      const url = tab.dataset.collectionUrl;
      if (!url) return null;
      const sep = url.includes('?') ? '&' : '?';
      const res = await fetch(url + sep + 'section_id=ff-pdc-tab');
      if (!res.ok) throw new Error('PDC tab fetch ' + res.status);
      const tmp = document.createElement('div');
      tmp.innerHTML = await res.text();
      const slides = Array.from(tmp.querySelectorAll('li.splide__slide')).map(li => li.outerHTML).join('');
      this.cache[index] = slides;
      return slides;
    }

    async handleTabClick(e) {
      const tab = e.currentTarget;
      if (tab.classList.contains('ff-pdc-tab--active')) return;

      this.tabs.forEach(t => t.classList.remove('ff-pdc-tab--active'));
      tab.classList.add('ff-pdc-tab--active');

      const showAllLink = this.querySelector('[data-show-all-link]');
      if (showAllLink && tab.dataset.collectionUrl) showAllLink.href = tab.dataset.collectionUrl;

      if (!this.splideInstance) return;

      let slides;
      try {
        slides = await this.fetchTab(tab);
      } catch (err) {
        return;
      }
      if (slides == null) return;

      const list = this.ffSlider.querySelector('.splide__list');
      list.innerHTML = slides;
      this.splideInstance.go(0);
      this.splideInstance.refresh();
    }
  });
}
